var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.4 69",
    style: {
      enableBackground: "new 0 0 64.4 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.8,68.5H16.4c-8.9,0-16.1-7.2-16.1-16.1V40.2c0-8.9,7.2-16.1,16.1-16.1h31.4c8.9,0,16.1,7.2,16.1,16.1v12.2 C63.9,61.2,56.6,68.5,47.8,68.5z M16.4,28.1c-6.7,0-12.1,5.4-12.1,12.1v12.2c0,6.7,5.4,12.1,12.1,12.1h31.4 c6.7,0,12.1-5.4,12.1-12.1V40.2c0-6.7-5.4-12.1-12.1-12.1H16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,20.3c-0.2,0-0.3,0-0.5-0.1c-1.1-0.3-1.7-1.3-1.5-2.4C14.4,7.9,22.7,0.9,32.2,0.9c9.2,0,17.4,6.7,20,16.2 c0.3,1.1-0.3,2.2-1.4,2.5s-2.2-0.3-2.5-1.4c-2.1-7.8-8.7-13.3-16.1-13.3c-7.6,0-14.3,5.7-16.3,13.8C15.7,19.6,14.9,20.3,14,20.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.e8f37d687764972649d0fd83db65f6f3.svg";
export { ForwardRef as ReactComponent };